import { useEffect } from 'react';
import { useState } from 'react';
import { Divider, Fab, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RepeaterItem from './RepeaterItem';

export interface IRepeaterItem {
  inEdit?: boolean;
}

export interface IRepeaterForm {
  onSave?: (data: IRepeaterItem) => void;
  data?: IRepeaterItem;
}

interface RepeaterProps<T extends IRepeaterItem> {
  data: T[];
  onUpdateData: (data: T, index: number) => void;
  addNewItem: () => void;
  onDeleteItem: (index: number) => void;
  Form: JSX.Element;
  children?: React.ReactNode;
  titleField?: string;
  subTitleField?: string;
}

const Repeater = <T extends IRepeaterItem>(props: RepeaterProps<T>) => {
  const { data, onUpdateData, addNewItem, onDeleteItem, Form, titleField, subTitleField } = props;

  // create useState for an array of objects
  const [items, setItems] = useState<T[]>([]);

  useEffect(() => {
    setItems(data);
  }, [data]);

  const setInEdit = (index: number) => {
    let newItems = items.map((itm, i) => {
      itm.inEdit = i === index && !itm.inEdit;
      return itm;
    });

    setItems(newItems);
  };

  const onItemSave = (newData: T, index: number) => {
    onUpdateData(newData, index);
  };

  return (
    <>
      {items?.map((item, index) => (
        <div key={index}>
          <RepeaterItem
            item={item}
            titleField={titleField}
            subTitleField={subTitleField}
            index={index}
            Form={Form}
            onItemSave={onItemSave}
            onEditClicked={setInEdit}
            onDeleteItem={onDeleteItem}
          />
          <Divider sx={{}} />
        </div>
      ))}

      <Box sx={{ display: 'flex', alignItems: 'center', mt: 4, mb: 6 }}>
        <Fab aria-label="add" size="medium" onClick={addNewItem} sx={{ m: '0 auto' }} className="repeater__add-item">
          <AddIcon />
        </Fab>
      </Box>
    </>
  );
};

export default Repeater;
